export const unities = [
    { id: 'AMPOLA', label: 'AMPOLA' },
    { id: 'BALDE', label: 'BALDE'},
    { id: 'BANDEJ', label: 'BANDEJA' },
    { id: 'BARRA', label: 'BARRA' },
    { id: 'BISNAG', label: 'BISNAGA' },
    { id: 'BLOCO', label: 'BLOCO' },
    { id: 'BOBINA', label: 'BOBINA' },
    { id: 'BOMB', label: 'BOMBONA' },
    { id: 'CAPS', label: 'CAPSULA' },
    { id: 'CART', label: 'CARTELA' },
    { id: 'CENTO', label: 'CENTO' },
    { id: 'CJ', label: 'CONJUNTO' },
    { id: 'CM', label: 'CENTIMETRO' },
    { id: 'CM2', label: 'CENTIMETRO QUADRADO' },
    { id: 'CX', label: 'CAIXA' },
    { id: 'CX2', label: 'CAIXA COM 2 UNIDADES' },
    { id: 'CX3', label: 'CAIXA COM 3 UNIDADES' },
    { id: 'CX5', label: 'CAIXA COM 5 UNIDADES' },
    { id: 'CX10', label: 'CAIXA COM 10 UNIDADES' },
    { id: 'CX15', label: 'CAIXA COM 15 UNIDADES' },
    { id: 'CX20', label: 'CAIXA COM 20 UNIDADES' },
    { id: 'CX25', label: 'CAIXA COM 25 UNIDADES' },
    { id: 'CX50', label: 'CAIXA COM 50 UNIDADES' },
    { id: 'CX100', label: 'CAIXA COM 100 UNIDADES' },
    { id: 'DISP', label: 'DISPLAY' },
    { id: 'DUZIA', label: 'DÚZIA' },
    { id: 'EMBAL', label: 'EMBALAGEM' },
    { id: 'FARDO', label: 'FARDO' },
    { id: 'FOLHA', label: 'FOLHA' },
    { id: 'FRASCO', label: 'FRASCO' },
    { id: 'GALAO', label: 'GALÃO' },
    { id: 'GF', label: 'GARRAFA' },
    { id: 'GRAMAS', label: 'GRAMAS' },
    { id: 'JOGO', label: 'JOGO' },
    { id: 'KG', label: 'QUILOGRAMA' },
    { id: 'KIT', label: 'KIT' },
    { id: 'LATA', label: 'LATA' },
    { id: 'LITRO', label: 'LITRO' },
    { id: 'M', label: 'METRO' },
    { id: 'M2', label: 'METRO QUADRADO' },
    { id: 'M3', label: 'METRO CÚBICO' },
    { id: 'MILHEI', label: 'MILHEIRO' },
    { id: 'ML', label: 'MILILITRO' },
    { id: 'MWH', label: 'MEGAWATT HORA' },
    { id: 'PACOTE', label: 'PACOTE' },
    { id: 'PALETE', label: 'PALETE' },
    { id: 'PARES', label: 'PARES' },
    { id: 'PC', label: 'PEÇA' },
    { id: 'POTE', label: 'POTE' },
    { id: 'K', label: 'QUILATE' },
    { id: 'RESMA', label: 'RESMA' },
    { id: 'ROLO', label: 'ROLO' },
    { id: 'SACO', label: 'SACO' },
    { id: 'SACOLA', label: 'SACOLA' },
    { id: 'TAMBOR', label: 'TAMBOR' },
    { id: 'TANQUE', label: 'TANQUE' },
    { id: 'TON', label: 'TONELADA' },
    { id: 'TUBO', label: 'TUBO' },
    { id: 'UNID', label: 'UNIDADE' },
    { id: 'VASIL', label: 'VASILHAME' },
    { id: 'VIDRO', label: 'VIDRO' },
]
